import RequireAuth from '@/components/auth/RequireAuth'

/**
 * @param {{ children: import('react').ReactNode }} props
 */
export default function Protected({ children }) {
  return <RequireAuth>{children}</RequireAuth>
}
